// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZkB6crS0f0Ngxz4W {
  text-align: center;
  padding: 36px;
  font-size: 20px;
  font-family: Roboto;
  font-weight: 100;
  position: absolute;
  bottom: 0;
  width: 100%;
}

@media screen and (max-width: 1280px) {
  .ZkB6crS0f0Ngxz4W {
    padding: 25px;
    font-size: 12px;
  }
}

@media screen and (max-width: 1024px) {
  .ZkB6crS0f0Ngxz4W {
    padding: 47px;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":[".footer {\r\n  text-align: center;\r\n  padding: 36px;\r\n  font-size: 20px;\r\n  font-family: Roboto;\r\n  font-weight: 100;\r\n  position: absolute;\r\n  bottom: 0;\r\n  width: 100%;\r\n}\r\n\r\n@media screen and (max-width: 1280px) {\r\n  .footer {\r\n    padding: 25px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .footer {\r\n    padding: 47px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var footer = `ZkB6crS0f0Ngxz4W`;
export default ___CSS_LOADER_EXPORT___;
